import React from 'react'
import { useLocation } from 'react-router-dom'
import i18 from '../i18n'

function Location() {
  const location = useLocation()

  const setHeader = () => {
    switch (location.pathname) {
      case '/': {
        return i18.t('appl.subTitle')
      }
      case '/404': {
        return 'Error page'
      }
      default: {
        return null
      }
    }
  }
  return <div>{setHeader()}</div>
}

export default Location
